import api from './api';
import { User, LoginForm, RegisterForm, AuthResponse } from '../types';

export const authService = {
  // Вход в систему
  async login(credentials: LoginForm): Promise<AuthResponse> {
    const formData = new FormData();
    formData.append('username', credentials.email);
    formData.append('password', credentials.password);
    
    const response = await api.post('/api/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  },

  // Регистрация
  async register(userData: RegisterForm): Promise<User> {
    const response = await api.post('/api/auth/register', userData);
    return response.data;
  },

  // Получение текущего пользователя
  async getCurrentUser(): Promise<User> {
    const response = await api.get('/api/auth/me');
    return response.data;
  },

  // Выход из системы
  logout(): void {
    localStorage.removeItem('access_token');
  },

  // Проверка авторизации
  isAuthenticated(): boolean {
    return !!localStorage.getItem('access_token');
  },

  // Сохранение токена
  setToken(token: string): void {
    localStorage.setItem('access_token', token);
  },

  // Получение токена
  getToken(): string | null {
    return localStorage.getItem('access_token');
  }
};

